import Flickity from 'flickity'
import isNull from 'lodash/isNull'

export default class CollectionSuggestion {
    constructor() {
        this.cacheDom()
        this.initialize()
        this.bindEvents()
    }

    cacheDom() {
        this.flkty = null
        this.carousel = document.querySelector('.featured-products-carousel')
        this.nextArrow = document.querySelector('.featured-products-arrows.next')
        this.prevArrow = document.querySelector('.featured-products-arrows.prev')
    }

    initialize() {
        if (!isNull(this.carousel)) {
            this.flkty = new Flickity(this.carousel, {
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
            })
        }
    }

    bindEvents() {
        if (!isNull(this.nextArrow)) {
            this.nextArrow.addEventListener('click', () => {
                this.flkty.next(true, false)
            })

            this.prevArrow.addEventListener('click', () => {
                this.flkty.previous(true, false)
            })
        }
    }
}
